import { HStack, Icon, IconButton, Text } from "@chakra-ui/react";
import { useThemeColors } from "../../../../hooks/useThemeColors";
import { BehavioralSubject, Subject } from "../../../../services/Dtos";
import useIcons from "../../../../hooks/useIcons";

interface Props {
  subject?: Subject;
  behavioralSubject?: BehavioralSubject;
  handleEditSubject?: (subject: Subject) => void;
  handleEditBehavioralSubject?: (behavioralSubject: BehavioralSubject) => void;
}

function SubjectBar({
  subject,
  behavioralSubject,
  handleEditSubject,
  handleEditBehavioralSubject,
}: Props) {
  const icons = useIcons();
  const colors = useThemeColors();

  return (
    <HStack
      border="1px solid"
      borderColor={colors.border.subtle}
      px={3}
      py={2}
      borderRadius="md"
      justify="space-between"
      align="center"
      bg={colors.background.tertiary}
      transition="all 0.2s"
      _hover={{ bg: colors.schoolAccent.hover }}
    >
      <Text>{subject ? subject.subjectName : behavioralSubject?.name}</Text>

      <IconButton
        size={"xs"}
        onClick={
          handleEditSubject && subject
            ? () => handleEditSubject(subject)
            : handleEditBehavioralSubject && behavioralSubject
              ? () => handleEditBehavioralSubject(behavioralSubject)
              : undefined
        }
        aria-label={"edit subject"}
        variant="surface"
      >
        <Icon as={icons.utility.edit} />
      </IconButton>
    </HStack>
  );
}

export default SubjectBar;
